const INSERT_FILE_BUTTON = "insert-file-button";
const ROOT = "file-upload-viewer";
const FILE_UPLOAD_NAME_CONTAINER = "file-upload-name-container";
const FILE_UPLOAD_NAME = "file-upload-name";
const FILE_UPLOAD_EXTENSION = "file-upload-extension";
export {
  FILE_UPLOAD_EXTENSION,
  FILE_UPLOAD_NAME,
  FILE_UPLOAD_NAME_CONTAINER,
  INSERT_FILE_BUTTON,
  ROOT
};
//# sourceMappingURL=data-hooks.js.map
